import { render, staticRenderFns } from "./AppCalendar.vue?vue&type=template&id=065b5ffd&scoped=true&"
import script from "./AppCalendar.vue?vue&type=script&lang=js&"
export * from "./AppCalendar.vue?vue&type=script&lang=js&"
import style0 from "./AppCalendar.vue?vue&type=style&index=0&id=065b5ffd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065b5ffd",
  null
  
)

export default component.exports